// extracted by mini-css-extract-plugin
module.exports = {"contactWrapper":"Contact_contactWrapper__YdP9z","contactText":"Contact_contactText__20ziu","emailText":"Contact_emailText__1Bn-8"};